import { checkoutShippingCarrierServiceStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService";
import { css } from "styled-components";

checkoutShippingCarrierServiceStyles.noCarriersFoundText = {
    css: css`
        color: #ed1c24;
        font-size: 15px;
        font-weight: 600;
    `,
};
